import service from '@/assets/js/request'

//稍后联系
export const getClientSimpleSearch = (host, data = {}) => {
  return service({
    url: `${host}/api/client/simpleSearch`,
    method: 'get',
    params: data
  })
}

//获取客户信息列表
export const getClientInfoId = (host, data = {}) => {
  return service({
    url: `${host}/api/client/searchByAllPhone`,
    method: 'get',
    params: data
  })
  // return service({
  //   url: `${host}/api/client/searchClientByCall`,
  //   method: 'post',
  //   data
  // })
}

// 随路数据
export const getIvrAlongData = (host, data = {}) => {
  return service({
    url: `${host}/api/ivr/associatdata`,
    method: 'post',
    data,
    timeout: 60000
  })
}



// WEBPACK FOOTER //
// ./src/api/crm.js